import React from 'react';
import { PanelScroll } from './view/panelScroll';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'PanelScroll', 
  itemElt: (item, cmsOption) => <PanelScroll item={item} cmsOption={cmsOption} />
}